<template>
  <!-- Stop propagating of arrow key events to not change slides while inside this element -->
  <textarea
    v-if="multiline"
    :id="id"
    ref="input"
    v-model="value"
    class="w-full rounded-md border border-gray-300 px-2 py-1"
    :placeholder="placeholder"
    @keydown.arrow-left.stop
    @keydown.arrow-right.stop
  />
  <input
    v-else
    :id="id"
    ref="input"
    v-model="value"
    type="text"
    :placeholder="placeholder"
    class="w-full rounded-md border border-gray-300 px-2 py-1"
    @input="emits('updated')"
    @keydown.arrow-left.stop
    @keydown.arrow-right.stop
  />
</template>

<script setup lang="ts">
const emits = defineEmits<{
  (e: 'updated'): void;
}>();

const props = defineProps<{
  id: string;
  placeholder?: string;
  autofocus?: boolean;
  multiline?: boolean;
}>();

const value = defineModel<string>({ required: true });
const input = ref<HTMLInputElement>();

onMounted(() => {
  if (props.autofocus) {
    input.value?.focus();
  }
});
</script>
